import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, TextArea }           from "semantic-ui-react";
import MailSendContent              from "../../../domain/mail/send/MailSendContent";
import MailSendRepository           from "../../../domain/mail/send/MailSendRepository";
import MailSendSubject              from "../../../domain/mail/send/MailSendSubject";
import { ResKaState }               from "../../../index";
import MailSendDataSource           from "../../../infrastructure/datasource/mail/send/MailSendDataSource";
import ValidatorMessage             from "../message/ValidatorMessage";

const MailSendForm: FC = () => {
  const repository: MailSendRepository = new MailSendDataSource(useDispatch());
  const subject: MailSendSubject = useSelector((state: ResKaState) => state.mailSend.subject);
  const content: MailSendContent = useSelector((state: ResKaState) => state.mailSend.content);
  return (
    <>
      <Form>
        <Form.Field required>
          <label>メール件名</label>
          <Form.Input
            value={ subject.value }
            onChange={ (event, data) => repository.setMailSendSubject(new MailSendSubject(data.value)) }
          />
          <ValidatorMessage target="subject"/>
        </Form.Field>
        <Form.Field>
          <label>メール本文</label>
          <TextArea
            rows={ 20 }
            value={ content.value }
            onChange={ (event, data) => repository.setMailSendContent(new MailSendContent(data.value as string)) }
          />
        </Form.Field>
      </Form>
    </>
  );
};

export default MailSendForm;
